export default "__VITE_ASSET__234c89bf__"